"use client";
import React, { useCallback, useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Switch, FormControlLabel, Button, Box } from "@mui/material";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { FormLabel, Grid, Typography } from "@mui/material";
import CustomSwitch from "../../../../../components/Switch";
import axiosInstance from "../../../../../axios/axiosInstance";

export default function StartTime({
  fleetDetails,
  racePayload,
  activateSnackbarTab,
  onStartTimeUpdate,
}) {
  const [loading, setLoading] = React.useState(false);
  const [duplicateFlag, setDuplicateFlag] = React.useState(false);
  const [duplicateClass, setDuplicateClass] = React.useState("");
  const [payload, setPayload] = React.useState({});
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [editId, setEditId] = React.useState("");
  const gridRef = React.useRef(null); // Reference for DataGridPro
  const [gridApi, setGridApi] = useState(null);

  const [columnDefs] = useState([
    {
      field: "fleet",
      headerName: "FLEET",
      flex: 2.5,
      minWidth: 200,
      maxWidth: 350,
      cellStyle: {
        // paddingLeft: "0.25rem",
      },
    },
    {
      field: "hr",
      headerName: "HR",
      editable: true,
      flex: 1,
      minWidth: 50,
      maxWidth: 100,
      cellEditor: "agTextCellEditor",
      cellEditorParams: {
        maxLength: 2,
      },
      valueSetter: (params) => {
        const newValue = params.newValue;
        if (
          /^\d*$/.test(newValue) &&
          newValue.length <= 2 &&
          parseInt(newValue) < 24
        ) {
          params.data.hr = newValue;
          return true;
        }
        return false;
      },
      onCellValueChanged: (params) => {
        if (params.newValue && params.newValue.length === 1) {
          params.node.setDataValue("hr", params.newValue.padStart(2, "0"));
        }
      },
    },
    {
      field: "min",
      headerName: "MIN",
      editable: true,
      flex: 1,
      minWidth: 50,
      maxWidth: 100,
      cellEditor: "agTextCellEditor",
      cellEditorParams: {
        maxLength: 2,
      },
      valueSetter: (params) => {
        const newValue = params.newValue;
        if (/^\d*$/.test(newValue) && newValue.length <= 2) {
          if (
            newValue === "" ||
            (parseInt(newValue) >= 0 && parseInt(newValue) < 60)
          ) {
            params.data.min = newValue;
            return true;
          }
        }
        return false;
      },
      onCellValueChanged: (params) => {
        if (params.newValue && params.newValue.length === 1) {
          params.node.setDataValue("min", params.newValue.padStart(2, "0"));
        }
      },
    },
    {
      field: "sec",
      headerName: "SEC",
      editable: true,
      flex: 1,
      minWidth: 50,
      maxWidth: 100,
      cellEditor: "agTextCellEditor",
      cellEditorParams: {
        maxLength: 2,
      },
      valueSetter: (params) => {
        const newValue = params.newValue;
        if (/^\d*$/.test(newValue) && newValue.length <= 2) {
          if (
            newValue === "" ||
            (parseInt(newValue) >= 0 && parseInt(newValue) < 60)
          ) {
            params.data.sec = newValue;
            return true;
          }
        }
        return false;
      },
      onCellValueChanged: (params) => {
        if (params.newValue && params.newValue.length === 1) {
          params.node.setDataValue("sec", params.newValue.padStart(2, "0"));
        }
      },
    },
  ]);
  const [rowData] = useState([
    { actions: "", fleet: "Div 1", hr: "00", min: "00", sec: "00" },
  ]);

  React.useEffect(() => {
    console.log("THe class changed", duplicateClass);
    if (gridApi != null) gridApi.refreshCells({ force: true });
  }, [duplicateClass]);

  const toggleDuplicateFlag = () => {
    setDuplicateFlag((prev) => !prev); // Toggle flag

    if (gridApi) {
      setTimeout(() => {
        gridApi.redrawRows(); // Refresh grid rows
      }, 100);
    }
  };

  const getRowClassName = (params) => {
    console.log("THE DAATAA", fleetDetails);
    console.log("THE HR", params);
    const duplicates = fleetDetails.filter(
      (row) =>
        row.hr === params.data.hr &&
        row.min === params.data.min &&
        row.sec === params.data.sec
    );
    //  return duplicates.length > 1 ? duplicateClass : "";

    return params.context.duplicateFlag && duplicates.length > 1
      ? "duplicateDataRow"
      : "";
  };

  console.log(fleetDetails, "fleetDetails");

  const handleUpdateRaceSessionDetails = async () => {
    let dbStartTimes = racePayload;
    console.log("TEST 3");
    for (let i = 0; i < fleetDetails.length; i++) {
      for (let j = 0; j < dbStartTimes.raceSessionsDetailList.length; j++) {
        if (
          fleetDetails[i]["id"] ===
          dbStartTimes.raceSessionsDetailList[j]["raceSessionDetailId"]
        ) {
          dbStartTimes.raceSessionsDetailList[j]["startTimeHH"] =
            fleetDetails[i]["hr"];
          dbStartTimes.raceSessionsDetailList[j]["startTimeMM"] =
            fleetDetails[i]["min"];
          dbStartTimes.raceSessionsDetailList[j]["startTimeSS"] =
            fleetDetails[i]["sec"];
          break;
        }
      }
    }
    try {
      const UPDATE_FLEET_API = "api/clubs/FinishTime/update";
      const response = await axiosInstance.post(UPDATE_FLEET_API, dbStartTimes);
      activateSnackbarTab("Start Times Updated Successfully", "success", true);
      if (onStartTimeUpdate) {
        onStartTimeUpdate([...fleetDetails]);
      }
    } catch (error) {
      //window.location.reload();
      activateSnackbarTab(error.response.data.message, "error", true);
    }
  };
  const getRowStyle = () => ({
    marginBottom: "10px",
    // borderBottom: "6px solid #f1f7f9",
  });

  // dynamic values
  const columnHeaderHeight = 36;
  const rowHeight = 36;

  return (
    <>
      <Grid container>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Box sx={{ marginBottom: "12px" }}>
            <Typography
              variant="h4"
              className="ty_form_heading"
              sx={{ marginTop: "0 !important" }}
            >
              Starts
            </Typography>
          </Box>
        </Grid>
        <Grid item xl={6} lg={6} md={6} sm={12} xs={12} sx={{ mb: 1 }}>
          <FormLabel className="ty-uppercase-label">
            Mark duplicate times
          </FormLabel>

          <FormControlLabel
            control={
              <CustomSwitch
                checked={duplicateFlag}
                handleCheckboxChange={toggleDuplicateFlag}
                disabled={false}
                name={"Duplicate_Flag"}
              />
            }
            label={duplicateFlag ? "Yes" : "No"}
            labelPlacement="end"
            sx={{ paddingLeft: "5px" }}
          />
        </Grid>
        <Grid
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          sx={{
            textAlign: "right",
          }}
        >
          <Button
            className="ty_primary_btn"
            sx={{ marginBottom: { xs: "8px", sm: "8px", md: "8px" } }}
            onClick={handleUpdateRaceSessionDetails}
          >
            Update
          </Button>
        </Grid>
      </Grid>
      <Box>
        <div
          className="ag-theme-alpine"
          style={{ height: "auto", maxHeight: "100%", width: "100%" }}
        >
          <AgGridReact
            className="ty_inlineEdit_datagrid"
            context={{ duplicateFlag }}
            columnDefs={columnDefs}
            rowData={fleetDetails}
            headerHeight={columnHeaderHeight}
            rowHeight={rowHeight}
            stopEditingWhenCellsLoseFocus={true}
            domLayout="autoHeight"
            defaultColDef={{
              sortable: false,
              filter: false,
              resizable: true,
              flex: 1,
            }}
            onGridReady={(params) => {
              params.api.sizeColumnsToFit();
              setGridApi(params.api);
            }}
            getRowStyle={getRowStyle}
            getRowClass={getRowClassName} // Updated to `getRowClass` (correct AG Grid property)
            animateRows={true} // Optional: Enables smooth row animations
            suppressRowHoverHighlight={false} // Optional: Highlight rows on hover
          />
        </div>
      </Box>
    </>
  );
}
